export default __webpack_public_path__ + "static/6585-4ba9ea2e61d34355b5bb392bbbcab58f.jpg";